export default __webpack_public_path__ + "static/media/logo.e7ce5113.png";